module.exports = __webpack_public_path__ + "static/media/family_us_alt.0ee2feaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Homepage/family_us_alt.png
// module id = 353
// module chunks = 0